import { render } from "./no_translate_keys.vue?vue&type=template&id=139bc9b7"
import script from "./no_translate_keys.vue?vue&type=script&lang=js"
export * from "./no_translate_keys.vue?vue&type=script&lang=js"

import "./no_translate_keys.vue?vue&type=style&index=0&id=139bc9b7&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__